import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * UserProfile — 헤더 우측 사용자 프로필 표시 컴포넌트
 *
 * 표시 내용:
 * - 프로필 이미지(원형 아바타) + 닉네임
 * - 프로필 이미지가 없으면 닉네임 첫 글자를 아바타로 표시
 * - 드롭다운 없음 (설정/로그아웃은 왼쪽 네비게이션에서 제공)
 */
const UserProfile = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const nickname = user?.nickname || user?.name || '사용자';
  const profileImageUrl = user?.profile_image_url || user?.profileImageUrl || null;
  const initial = nickname.charAt(0);

  return (
    <div className="user-profile">
      <div className="user-profile__trigger">
        {profileImageUrl ? (
          <img
            src={profileImageUrl}
            alt={`${nickname} 프로필`}
            className="user-profile__avatar"
          />
        ) : (
          <span className="user-profile__avatar user-profile__avatar--initial">
            {initial}
          </span>
        )}
        <span className="user-profile__nickname">{nickname}</span>
      </div>
    </div>
  );
};

export default React.memo(UserProfile);
